/* Content stays visible without JavaScript; entrance motion runs once below the fold. */
(() => {
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const seen = new WeakSet();
  let observer;
  const selectors = '#main-content .bh3d-banners__card, #main-content .bh3d-shop-links__card';
  function watch(root = document) {
    if (motion.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
    if (!observer) observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        if (!motion.matches) entry.target.animate(
          [{transform: 'translateY(18px)'}, {transform: 'translateY(0)'}],
          {duration: 550, easing: 'cubic-bezier(.2,.65,.3,1)'}
        );
      });
    }, {threshold: .08});
    root.querySelectorAll(selectors).forEach(card => {
      if (seen.has(card)) return;
      seen.add(card);
      if (card.getBoundingClientRect().top >= window.innerHeight) observer.observe(card);
    });
  }
  function reduce() {
    if (motion.matches) {
      observer?.disconnect();
      document.querySelectorAll(selectors).forEach(card => card.getAnimations().forEach(animation => animation.cancel()));
    }
  }
  watch();
  motion.addEventListener('change', reduce);
  document.addEventListener('shopify:section:load', () => watch());
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll(selectors).forEach(card => observer?.unobserve(card));
  });
})();